var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBelote24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_belote24x24",
    transform: "translate(-2.985 -4.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    d: "M9.414,19.164l-4.41.4a.906.906,0,0,1-1.1-.9h0L3,9.421a1.037,1.037,0,0,1,.9-1.205h0l1.7-.2-.5,8.939a1.729,1.729,0,0,0,1.6,1.908h.1Zm-.6-1.607a1.818,1.818,0,0,1-1.5-2.109l1.4-8.537-1.1-.1a1.031,1.031,0,0,0-1.1,1l-.6,9.24a1.031,1.031,0,0,0,1,1.1l6.114.4c.2,0,.4,0,.5-.2Zm2.2-1.406a1.944,1.944,0,0,1-1.3-2.31L12.02,5.805l-1.3-.2a1.04,1.04,0,0,0-1.2.8l-1.5,9.14a1.042,1.042,0,0,0,.8,1.205l6.114,1a.778.778,0,0,0,.8-.2ZM20.94,7.613l-2.606,8.839a1.148,1.148,0,0,1-1.3.7l-5.913-1.707a1.151,1.151,0,0,1-.7-1.306L13.022,5.3a1.148,1.148,0,0,1,1.3-.7l5.913,1.707a.981.981,0,0,1,.7,1.205c.1,0,0,0,0,.1Zm-3.508,3.114c-.1,0-.1,0-.2-.1.2-.2.3-.4.5-.6a1.374,1.374,0,0,0-.7-1.707,1.3,1.3,0,0,0-1.7.8h0a1.492,1.492,0,0,0-.1.7h-.1a1.294,1.294,0,0,0-1.7.7,1.437,1.437,0,0,0,.7,1.707,1.323,1.323,0,0,0,1.2-.2l-.4,1,.4.2.4-1a1.225,1.225,0,0,0,.8.9,1.25,1.25,0,0,0,1.7-.7v-.1a1.316,1.316,0,0,0-.8-1.607Z",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBelote24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_belote24x24.790706e0633529bdca852f9e2a3c78ed.svg";